<template>
  <el-dialog title="报告邮寄登记" :visible.sync="dialogVisible" width="1000px" :before-close="closeDialog" :close-on-click-modal="false">
    <el-form :model="form" ref="form" :rules="rules" label-width="120px">
      <!-- 头部信息 -->
      <el-row :gutter="24">
        <el-col :span="16">
          <el-form-item label="常用邮寄信息" prop="mailingInfo">
            <el-input v-model="form.mailingInfo" type="textarea" :rows="3" placeholder="请输入常用邮寄信息（收件人、地址、电话等）" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮寄时间" prop="mailingDate">
            <el-date-picker v-model="form.mailingDate" type="date" placeholder="选择邮寄时间" value-format="yyyy-MM-dd" style="width: 100%;" />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 列表部分 -->
      <el-divider content-position="left">报告列表</el-divider>
      <el-table :data="form.reportList" border style="width: 100%; margin-top: 10px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }" max-height="400">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="客户名称" align="center" prop="compName" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="使用单位名称" align="center" prop="usingUnit" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column label="识别码" align="center" prop="OIDNO" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="回款时间" align="center" prop="receiptTime" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.receiptTime === null ? '-' : scope.row.receiptTime }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="confirmSubmit" :loading="submitLoading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// TODO: 导入API方法
import { registerMail } from '@/api/contract/contract';

export default {
  name: 'MailingRegister',
  data () {
    return {
      dialogVisible: false,
      submitLoading: false,
      form: {
        mailingInfo: '',
        mailingDate: '',
        reportList: []
      },
      rules: {
        mailingInfo: [
          { required: true, message: '请输入常用邮寄信息', trigger: 'blur' }
        ],
        mailingDate: [
          { required: true, message: '请选择邮寄时间', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    // 打开对话框
    openDialog (selectedRows) {
      // 设置默认邮寄时间为当天
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const defaultDate = `${year}-${month}-${day}`;

      // 收集所有不同客户的邮寄信息
      let defaultMailingInfo = '';
      if (selectedRows && selectedRows.length > 0) {
        // 使用 Map 去重，key 为客户名称，value 为邮寄信息
        const mailingInfoMap = new Map();
        selectedRows.forEach(row => {
          if (row.compName && row.mailingInfo && !mailingInfoMap.has(row.compName)) {
            mailingInfoMap.set(row.compName, row.mailingInfo);
          }
        });

        // 将所有邮寄信息用 / 分隔
        if (mailingInfoMap.size > 0) {
          defaultMailingInfo = Array.from(mailingInfoMap.values()).join(' / ');
        }
      }

      this.form = {
        mailingInfo: defaultMailingInfo,
        mailingDate: defaultDate,
        reportList: selectedRows.map(row => ({
          id: row.id,
          compName: row.compName,
          usingUnit: row.usingUnit,
          OIDNO: row.OIDNO,
          paymentDate: row.paymentDate || '', // 回款时间来源于收款功能
          entrustNum: row.entrustNum,
          receiptTime: row.receiptTime
        }))
      };

      this.dialogVisible = true;
    },
    // 关闭对话框
    closeDialog () {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.form.reportList = [];
    },
    // 确认提交
    confirmSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.reportList.length === 0) {
            this.$message.warning('报告列表不能为空');
            return;
          }

          this.submitLoading = true;

          // 构建请求参数
          const params = {
            mailingInfo: this.form.mailingInfo,
            mailingDate: this.form.mailingDate,
            items: this.form.reportList.map(item => ({
              entrustNum: item.entrustNum
            }))
          };

          registerMail(params).then(res => {
            if (res && res.retCode === 'ok') {
              this.$message.success('邮寄登记成功');
              this.closeDialog();
              this.$emit('refresh');
            } else {
              this.$message.error((res && res.retMsg) || '邮寄登记失败');
            }
            this.submitLoading = false;
          }).catch(error => {
            console.error('邮寄登记失败:', error);
            this.$message.error('邮寄登记失败');
            this.submitLoading = false;
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.el-divider {
  margin: 20px 0;
}
</style>
